import React from 'react';
import '../css/ProjectDetails.css';



export default class ProjectDetails extends React.Component{
    render(){
        return (
            <div className="projectdetails ">
               Project Details of the page
            </div>
        );
    }
}
